import { applySpellCheckFix } from './applySpellCheckFix';
import { removeSpellCheckPopup } from './removeSpellCheckPopup';

/**
 * Escape HTML to prevent XSS attacks
 * @param {string} text
 * @returns {string}
 */
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Create error item for the popup
 * @param {fabric.Textbox} textbox
 * @param {object} match
 * @param {HTMLElement} popup
 */
export function createErrorItem(textbox, match, popup) {
  const errorText = textbox.text.substring(
    match.offset,
    match.offset + match.length
  );
  const hasReplacements = match.replacements && match.replacements.length > 0;
  const containerClass = hasReplacements ? 'fixable' : 'informational';
  const errorTextClass = hasReplacements ? 'fixable' : 'informational';

  // Build error header HTML
  const errorHeaderHtml = `
    <div class="error-header">
      <strong class="error-text ${errorTextClass}">${escapeHtml(
    errorText
  )}</strong>
      ${hasReplacements ? ' →' : ''}
    </div>
  `;

  // Build error message HTML
  const errorMessageHtml = match.message
    ? `
    <div class="error-message">${escapeHtml(match.message)}</div>
  `
    : '';

  // Build suggestions or info HTML
  let contentHtml = '';
  if (hasReplacements) {
    const suggestionsHtml = match.replacements
      .map(
        (replacement) => `
      <div class="spellcheck-suggestion-item" data-replacement="${escapeHtml(
        replacement.value
      )}">
        <span class="suggestion-text">${escapeHtml(replacement.value)}</span>
        <span class="accept-label">Accetta</span>
      </div>
    `
      )
      .join('');
    contentHtml = suggestionsHtml;
  } else {
    contentHtml = `
      <div class="spellcheck-info-item">
        Nessuna correzione automatica disponibile
      </div>
    `;
  }

  // Compose complete error container HTML
  const errorContainerHtml = `
    <div class="spellcheck-error-container ${containerClass}">
      ${errorHeaderHtml}
      ${errorMessageHtml}
      ${contentHtml}
    </div>
  `;

  // Create container and set innerHTML
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = errorContainerHtml;
  const errorContainer = tempDiv.firstElementChild;

  // Add event listeners to suggestion items
  if (hasReplacements) {
    const suggestionItems = errorContainer.querySelectorAll(
      '.spellcheck-suggestion-item'
    );
    suggestionItems.forEach((item, index) => {
      const replacement = match.replacements[index];
      item.addEventListener('click', () => {
        applySpellCheckFix(textbox, match, replacement.value);
        removeSpellCheckPopup(true); // Force removal after fix
      });
    });
  }

  popup.appendChild(errorContainer);
}
